// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#difficultyOptionsWrapper{
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    background: #F7F7F7;
    padding: 8px;
    border-radius: 5px;
    justify-content: center;
}

.arc{
    position: absolute;
    width: 40px;
    height: 40px;
    transform: rotate(46deg);
}

.arc-background{
    position: absolute;
    border-radius: 50%;
    border: 8px solid white;
    margin-top: -1px;
    width: 42px;
    height: 42px;
}

.easyLevelArc{
    border-top: 6px solid #0AC2AA;
    border-right: 6px solid #0AC2AA;
    border-bottom: 6px solid #0AC2AA;
    border-left: 6px solid #EBCF71;
    border-radius: 50%;
}

.mediumLevelArc{
    border-right: 6px solid #EBCF71;
    border-left: 6px solid #EBCF71;
    border-top: 6px solid #EBCF71;
    border-bottom: 6px solid #EBCF71;
    border-radius: 50%;
}

.balancedLevelArc{
    border-top: 6px solid #0AC2AA;
    border-right: 6px solid #EBCF71;
    border-bottom: 6px solid #EBCF71;
    border-left: 6px solid #DE4D5D;
    border-radius: 50%;
}

.hardArc{
    border-top: 6px solid #EBCF71;
    border-right: 6px solid #EBCF71;
    border-bottom: 6px solid #EBCF71;
    border-left: 6px solid #DE4D5D;
    border-radius: 50%;
}

.optionWrapper{
    min-width: 124px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 20%);
    padding: 8px;
    border-radius: 5%;
    cursor: pointer;
    background: #ffffff;
}

.arcWrapper{
    height: 60px;
    display: flex;
    justify-content: center;
}

.textWrapper{
    display: flex;
    flex-direction: column;
    height: 46px;
    line-height: 16px;
    justify-content: center;
    gap: 0;
    text-shadow: 1px 1px 2px #ffffff;
    margin-top: -8px;
}

.difficultySelectWrapper{
    display:flex;
    flex-direction: column;
    padding: 6px;
    border-radius: 5px;
    height: 86px;
}

.difficultySelectWrapper .textWrapper{
    /*line-height: 36px;*/
    margin-left: 8px;
    margin-top: -3px;
    text-align: center;
}

.difficultySelectWrapper, #difficultyOptionsWrapper .optionWrapper.selected {
    background: rgba(var(--primary-colour-RGB), 0.1);
}

#generateSummary > * {
    padding: 8px 0;
}

#generateSummary > *:first-child {
    padding: 0;
    margin-bottom: 0;
}

#generateSummary {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
}

#detailsFormWrapper, .wizard-sub-cont {
    display: flex;
    flex-direction: column;
    padding: 0 8px;
}

#diagnosticWizardTabTextbook, #diagnosticWizardTabCurriculum {
    padding: 4px;
}

#testDetailsForm .ant-form-item-label {
    padding-top: 6px;
}

#selectedConceptList {
    overflow: auto;
    max-height: 200px;
}

.ch-diagnostics-pretest h3 {
    color: var(--secondary-colour) !important;
}

#diagnosticWizardTree .ant-tabs-content {
    padding-top: 8px;
}

#wizardGenerateCont {
    display: flex;
    flex-direction: column;
}

#wizardGenerateCont > * {
    padding: 4px 0;
}

#wizardGenerateCont div {
    display: flex;
    justify-content: end;
}

#wizardGenerateCont > *:first-child {
    padding-top: 12px;
}`, "",{"version":3,"sources":["webpack://./src/main/ui/tests/teacher/Diagnostics/TestGroups/Wizard/main.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,MAAM;IACN,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["#difficultyOptionsWrapper{\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n    background: #F7F7F7;\n    padding: 8px;\n    border-radius: 5px;\n    justify-content: center;\n}\n\n.arc{\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    transform: rotate(46deg);\n}\n\n.arc-background{\n    position: absolute;\n    border-radius: 50%;\n    border: 8px solid white;\n    margin-top: -1px;\n    width: 42px;\n    height: 42px;\n}\n\n.easyLevelArc{\n    border-top: 6px solid #0AC2AA;\n    border-right: 6px solid #0AC2AA;\n    border-bottom: 6px solid #0AC2AA;\n    border-left: 6px solid #EBCF71;\n    border-radius: 50%;\n}\n\n.mediumLevelArc{\n    border-right: 6px solid #EBCF71;\n    border-left: 6px solid #EBCF71;\n    border-top: 6px solid #EBCF71;\n    border-bottom: 6px solid #EBCF71;\n    border-radius: 50%;\n}\n\n.balancedLevelArc{\n    border-top: 6px solid #0AC2AA;\n    border-right: 6px solid #EBCF71;\n    border-bottom: 6px solid #EBCF71;\n    border-left: 6px solid #DE4D5D;\n    border-radius: 50%;\n}\n\n.hardArc{\n    border-top: 6px solid #EBCF71;\n    border-right: 6px solid #EBCF71;\n    border-bottom: 6px solid #EBCF71;\n    border-left: 6px solid #DE4D5D;\n    border-radius: 50%;\n}\n\n.optionWrapper{\n    min-width: 124px;\n    text-align: center;\n    border: 1px solid rgba(0, 0, 0, 20%);\n    padding: 8px;\n    border-radius: 5%;\n    cursor: pointer;\n    background: #ffffff;\n}\n\n.arcWrapper{\n    height: 60px;\n    display: flex;\n    justify-content: center;\n}\n\n.textWrapper{\n    display: flex;\n    flex-direction: column;\n    height: 46px;\n    line-height: 16px;\n    justify-content: center;\n    gap: 0;\n    text-shadow: 1px 1px 2px #ffffff;\n    margin-top: -8px;\n}\n\n.difficultySelectWrapper{\n    display:flex;\n    flex-direction: column;\n    padding: 6px;\n    border-radius: 5px;\n    height: 86px;\n}\n\n.difficultySelectWrapper .textWrapper{\n    /*line-height: 36px;*/\n    margin-left: 8px;\n    margin-top: -3px;\n    text-align: center;\n}\n\n.difficultySelectWrapper, #difficultyOptionsWrapper .optionWrapper.selected {\n    background: rgba(var(--primary-colour-RGB), 0.1);\n}\n\n#generateSummary > * {\n    padding: 8px 0;\n}\n\n#generateSummary > *:first-child {\n    padding: 0;\n    margin-bottom: 0;\n}\n\n#generateSummary {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n#detailsFormWrapper, .wizard-sub-cont {\n    display: flex;\n    flex-direction: column;\n    padding: 0 8px;\n}\n\n#diagnosticWizardTabTextbook, #diagnosticWizardTabCurriculum {\n    padding: 4px;\n}\n\n#testDetailsForm .ant-form-item-label {\n    padding-top: 6px;\n}\n\n#selectedConceptList {\n    overflow: auto;\n    max-height: 200px;\n}\n\n.ch-diagnostics-pretest h3 {\n    color: var(--secondary-colour) !important;\n}\n\n#diagnosticWizardTree .ant-tabs-content {\n    padding-top: 8px;\n}\n\n#wizardGenerateCont {\n    display: flex;\n    flex-direction: column;\n}\n\n#wizardGenerateCont > * {\n    padding: 4px 0;\n}\n\n#wizardGenerateCont div {\n    display: flex;\n    justify-content: end;\n}\n\n#wizardGenerateCont > *:first-child {\n    padding-top: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
